export const FETCH_BANNER = 'FETCH_BANNER';
export const FETCH_BANNER_SUCCESS = 'FETCH_BANNER_SUCCESS';
export const FETCH_BANNER_FAILED = 'FETCH_BANNER_FAILED';

export const SAVE_BANNER_ORDER = 'SAVE_BANNER_ORDER';
export const SAVE_BANNER_ORDER_SUCCESS = 'SAVE_BANNER_ORDER_SUCCESS';
export const SAVE_BANNER_ORDER_FAILED = 'SAVE_BANNER_ORDER_FAILED';
